<div class="upload-state" *ngIf="show === false">
  <h2>Acceso denegado</h2>
</div>
<div class="upload-state" *ngIf="show === true && validate === false">
  <h2>Acceso denegado</h2>
</div>
<div class="upload-state upload-state--success" *ngIf="showUploaded">
  <h2>
    La operación se ha realizado con éxito, gracias por utilizar nuestros
    servicios, ya puede cerrar esta página.
  </h2>
</div>

<div
  class="docs"
  [class.docs--tdgt]="isTDGT"
  *ngIf="show === true && validate === true && !showUploaded"
>
  <h2 class="docs__heading">Adjuntar archivos</h2>

  <header class="docs__header">
    <h3 class="docs__title">Documentos</h3>
    <div
      class="docs__meta"
      [class.docs__meta--exceeded]="sumFileSize > maxSum"
    >
      <span class="docs__meta-value">
        {{ formatBytes(sumFileSize) }} / {{ formatBytes(maxSum) }}
      </span>
      <span class="docs__meta-warning" *ngIf="sumFileSize > maxSum">
        — Tamaño total excedido
      </span>
    </div>
  </header>

  <div class="docs__search">
    <svg class="docs__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <input
      type="text"
      class="docs__search-input"
      [(ngModel)]="searchTerm"
      placeholder="Buscar documento…"
      aria-label="Buscar documento"
    />
    <button
      type="button"
      class="docs__search-clear"
      *ngIf="searchTerm"
      (click)="searchTerm = ''"
      aria-label="Limpiar búsqueda"
    >×</button>
  </div>

  <section class="docs__section" *ngIf="tokenInfo">
    <button
      type="button"
      class="docs__section-header"
      (click)="toggleSection('tramite')"
      [attr.aria-expanded]="effectiveExpanded('tramite')"
    >
      <h4 class="docs__section-title">Documentos del trámite</h4>
      <svg
        class="docs__section-chevron"
        [class.docs__section-chevron--open]="effectiveExpanded('tramite')"
        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <div class="docs__list" *ngIf="effectiveExpanded('tramite')">
      <app-document-slot
        *ngIf="tokenInfo.comprador || tokenInfo.tramites"
        label="DNI Comprador"
        [numero]="0"
        [files]="filesDniComprador"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 0)"
        (fileRemoved)="deleteFile($event, 0)"
      ></app-document-slot>

      <app-document-slot
        *ngIf="!tokenInfo.comprador || tokenInfo.tramites"
        label="DNI Vendedor"
        [numero]="1"
        [files]="filesDniVendedor"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 1)"
        (fileRemoved)="deleteFile($event, 1)"
      ></app-document-slot>

      <app-document-slot
        *ngIf="!tokenInfo.comprador || tokenInfo.tramites"
        label="Factura / Contrato Compraventa"
        [numero]="7"
        [files]="fileFactura"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 7)"
        (fileRemoved)="deleteFile($event, 7)"
      ></app-document-slot>

      <app-document-slot
        *ngIf="!tokenInfo.comprador || tokenInfo.tramites || isMoves"
        label="Ficha Técnica"
        [numero]="8"
        [files]="fileFicha"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 8)"
        (fileRemoved)="deleteFile($event, 8)"
      ></app-document-slot>

      <app-document-slot
        *ngIf="!tokenInfo.comprador || tokenInfo.tramites"
        label="Permiso de Circulación"
        [numero]="9"
        [files]="filePermiso"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 9)"
        (fileRemoved)="deleteFile($event, 9)"
      ></app-document-slot>

      <app-document-slot
        *ngIf="!tokenInfo.comprador"
        label="Padrón / Justificante de Domicilio"
        [numero]="10"
        [files]="filesPadron"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 10)"
        (fileRemoved)="deleteFile($event, 10)"
      ></app-document-slot>

      <app-document-slot
        label="Otros Documentos"
        [numero]="15"
        [files]="fileOtros"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 15)"
        (fileRemoved)="deleteFile($event, 15)"
      ></app-document-slot>
    </div>
  </section>

  <section class="docs__section">
    <button
      type="button"
      class="docs__section-header"
      (click)="toggleSection('ayudas')"
      [attr.aria-expanded]="effectiveExpanded('ayudas')"
    >
      <div class="docs__section-titles">
        <h4 class="docs__section-title">Ayudas</h4>
        <p class="docs__section-subtitle">
          Documentos relativos a MOVES y otras ayudas
        </p>
      </div>
      <svg
        class="docs__section-chevron"
        [class.docs__section-chevron--open]="effectiveExpanded('ayudas')"
        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <div class="docs__list" *ngIf="effectiveExpanded('ayudas')">
      <app-document-slot
        label="Certificado de titularidad cuenta corriente"
        [numero]="58"
        [files]="fileTitularidadCta"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 58)"
        (fileRemoved)="deleteFile($event, 58)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de situación censal"
        [numero]="60"
        [files]="fileCenso"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 60)"
        (fileRemoved)="deleteFile($event, 60)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de residencia fiscal"
        [numero]="61"
        [files]="fileResidenciaFiscal"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 61)"
        (fileRemoved)="deleteFile($event, 61)"
      ></app-document-slot>

      <app-document-slot
        label="Licencia Taxi / VTC"
        [numero]="62"
        [files]="fileLicenciaTaxi"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 62)"
        (fileRemoved)="deleteFile($event, 62)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado de baja vehículo"
        [numero]="63"
        [files]="fileBaja"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 63)"
        (fileRemoved)="deleteFile($event, 63)"
      ></app-document-slot>

      <app-document-slot
        label="Permiso de circulación vehículo achatarrado"
        [numero]="64"
        [files]="filePcAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 64)"
        (fileRemoved)="deleteFile($event, 64)"
      ></app-document-slot>

      <app-document-slot
        label="Ficha técnica vehículo achatarrado"
        [numero]="65"
        [files]="fileFtAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 65)"
        (fileRemoved)="deleteFile($event, 65)"
      ></app-document-slot>

      <app-document-slot
        label="IVTM vehículo achatarrado"
        [numero]="50"
        [files]="fileIvtmAchatarrado"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 50)"
        (fileRemoved)="deleteFile($event, 50)"
      ></app-document-slot>

      <app-document-slot
        label="Escritura empresa / Certificado de poder"
        [numero]="51"
        [files]="fileEscritura"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 51)"
        (fileRemoved)="deleteFile($event, 51)"
      ></app-document-slot>

      <app-document-slot
        label="Expediente consorcio compensación de seguros"
        [numero]="52"
        [files]="fileExpedienteConsorcio"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 52)"
        (fileRemoved)="deleteFile($event, 52)"
      ></app-document-slot>

      <app-document-slot
        label="Proforma / Pedido"
        [numero]="53"
        [files]="fileProforma"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 53)"
        (fileRemoved)="deleteFile($event, 53)"
      ></app-document-slot>

      <app-document-slot
        label="Justificantes de pago / Entregas a cuenta"
        [numero]="54"
        [files]="fileJustificantePago"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 54)"
        (fileRemoved)="deleteFile($event, 54)"
      ></app-document-slot>

      <app-document-slot
        label="Contrato financiación / Leasing / Renting"
        [numero]="55"
        [files]="fileContratoLeasing"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 55)"
        (fileRemoved)="deleteFile($event, 55)"
      ></app-document-slot>

      <app-document-slot
        label="Certificado ayuda mínimis"
        [numero]="56"
        [files]="fileMinimis"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 56)"
        (fileRemoved)="deleteFile($event, 56)"
      ></app-document-slot>

      <app-document-slot
        label="Expediente ayudas"
        [numero]="57"
        [files]="fileExpedienteAyudas"
        [progress]="uploadProgress"
        [uploading]="spinnerFirma"
        [searchTerm]="searchTerm"
        (filesAdded)="onFileDropped($event, 57)"
        (fileRemoved)="deleteFile($event, 57)"
      ></app-document-slot>
    </div>
  </section>

  <div class="docs__progress" *ngIf="spinnerFirma">
    <div class="docs__progress-bar" [style.width.%]="uploadProgress"></div>
    <span class="docs__progress-label">Subiendo… {{ uploadProgress }}%</span>
  </div>

  <div class="docs__actions">
    <button
      *ngIf="isMoves"
      mat-button
      class="btn-secondary"
      (click)="volver()"
      [disabled]="spinnerFirma"
    >
      Volver
    </button>
    <button
      *ngIf="!isMoves"
      mat-button
      class="btn-secondary"
      mat-dialog-close
      [disabled]="spinnerFirma"
    >
      Cancelar
    </button>
    <button
      mat-button
      class="btn-primary"
      (click)="guardar()"
      [disabled]="spinnerFirma || sumFileSize > maxSum"
    >
      Guardar
    </button>
  </div>
</div>
